export const CONFIG = {
  creatorId: "6a85848ab7d31750d7785b8c",
  creatorName: "Meenu Soni",
  creatorTitle: "AI Coach & Digital Business Mentor",
  domain: "learn.claritycirclehub.com",
  webinarTitle: "AI Clarity Coach Launchpad",
  webinarSubtitle: "The Knowledge-to-Income System",
  webinarPromise: "Discover how to turn your knowledge, skills and experience into a clear coaching offer, digital product and AI-powered business system.",
  whatsappCommunityLink: "https://chat.whatsapp.com/EiyMiKNKmI7F0BDzH8ApMJ",
  launchpadLink: "https://learn.claritycirclehub.com/launchpad-offer",
  webhookUrl: "https://api-prod-new.tagmango.com/api/v1/webhooks/6a85848ab7d31750d7785b8c",
  defaultWebinarDate: "Saturday, Feb 21, 2026",
  defaultWebinarTime: "4:00 PM GMT",
};
